module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-c4798c1e.png";